import { useState, useEffect, useMemo } from "react";

import create from "react-easy-contexts";
import apiService from "../../services/api.service";
import { normalizeData } from "../../libs/utils";
import themeDefaults from "../../config/theme_defaults.json";

const apiClient = apiService.apiClient;

const ctx = create({
  useInstance() {
    const [theme, setInstanceTheme] = useState(null);
    const [settings, setSettings] = useState(null);
    const [info, setInfo] = useState(null);
    const [languageOverrides, setLanguageOverrides] = useState(null);
    const [loading, setLoading] = useState(true);

    // methods
    const loadInstance = async () => {
      const hostName = window.location.hostname;
      apiClient
        .get(`/instances?filters[urlMatch][$contains]=${hostName}&populate=*`)
        .then((res) => {
          // console.log('RES DATA', res);
          if (res.data) {
            let themeData = normalizeData(res.data.data[0]);
            // console.log(themeData);
            // Use instance theme if available, otherwise use defaults
            setInstanceTheme(themeData.themeOverrides || themeDefaults);
            setSettings(themeData.settings);
            setInfo({
              id: themeData.id,
              name: themeData.name,
              logo: themeData.logo,
              logos: themeData.logos,
              logo_alt: themeData.logo_alt,
              hero: themeData.hero,
            });
            setLanguageOverrides(themeData.languageOverrides);
            // load all fonts via @import from settings.imports
            if (themeData.settings?.imports) {
              themeData.settings.imports.forEach((font) => {
                // console.log("loading font", font);
                const link = document.createElement("link");
                link.href = font;
                link.rel = "stylesheet";
                document.head.appendChild(link);
              });
            }
          } else {
            // No instance data found, use defaults
            setInstanceTheme(themeDefaults);
          }
        })
        .catch((err) => {
          console.error("Failed to load instance:", err);
          // Use defaults on error
          setInstanceTheme(themeDefaults);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    // effects
    useEffect(() => {
      if (typeof window !== "undefined") {
        // Client-side-only code
        loadInstance();
      }
    }, []);

    // exports
    return useMemo(
      () => ({
        info,
        theme,
        settings,
        languageOverrides,
        loading,
      }),
      [info, theme, settings, languageOverrides, loading],
    );
  },
});

export default ctx;
